import { render, staticRenderFns } from "./GenericRecordPhotosCard.vue?vue&type=template&id=7a800dc2&scoped=true"
import script from "./GenericRecordPhotosCard.vue?vue&type=script&lang=js"
export * from "./GenericRecordPhotosCard.vue?vue&type=script&lang=js"
import style0 from "./GenericRecordPhotosCard.vue?vue&type=style&index=0&id=7a800dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a800dc2",
  null
  
)

export default component.exports